import React, { useState, useEffect } from 'react';
import { classList } from 'utils/componentsCommon';
import PropTypes from 'prop-types';

const VideoPlayer = ({ videoId, title, className, standAlone, thumbnail, autoPlay = false, controls = false, ...props }) => {
    const classNames = classList(
        'videoPlayer',
        className);
    let videoIdEmbed = videoId;

    if (videoIdEmbed && videoIdEmbed.indexOf('https://www.youtube.com/watch?v=') > -1) {
        videoIdEmbed = videoIdEmbed.replace('https://www.youtube.com/watch?v=', '');
    }

    const [autoPlayValue, setAutoPlayValue] = useState(autoPlay ? '&autoplay=1' : null);
    const [thumbnailValue, setThumbnail] = useState(thumbnail);

    const controlValue =  controls ? 1 : 0;
    const showPlayer = () => {
        setAutoPlayValue('&autoplay=1');
        setThumbnail(null);
    };
    useEffect(() => {
        if(autoPlay){
            showPlayer();
        }
    }, [autoPlay]);
    return (
        <>
            {
                thumbnailValue ?
                    (
                        <>
                            <div className={ classNames } { ...props } onClick={ () => showPlayer() }>
                                <div className="thumbnail" style={{ backgroundImage: `url(${thumbnail})` }}><div></div></div>
                            </div>
                        </>
                    )
                    :
                    (
                        <>
                            { videoIdEmbed &&
                            ( !standAlone ?
                                <div className={ classNames } { ...props }>
                                    <iframe
                                        src={ `https://www.youtube.com/embed/${videoIdEmbed}?color=white&controls=${controlValue}&cc_load_policy=1&modestbranding=1&rel=0${autoPlayValue}` }
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                        title={ title }
                                    />
                                </div>
                                :
                                <article className={ classNames } { ...props }>
                                    <iframe
                                        src={ `https://www.youtube.com/embed/${videoIdEmbed}?color=white&controls=0&modestbranding=1&rel=0${autoPlayValue}` }
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                        title={ title }
                                    />
                                </article>
                            )
                            }
                        </>)
            }

        </>
    );
};

VideoPlayer.propTypes = {
    videoId: PropTypes.string.isRequired,
    autoPlay: PropTypes.bool,
    controls: PropTypes.bool,
    thumbnail: PropTypes.string,
    standAlone: PropTypes.bool,
    className: PropTypes.string,
    title: PropTypes.string,
};

export default VideoPlayer;
